// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* Reserve vertical scrollbar space so expanding the equipment list does not shift the modal horizontally. */
.incident-detail-modal-body {
  overflow-y: scroll;
  scrollbar-gutter: stable;
}
.modal:has(.incident-detail-modal-body) {
  scrollbar-gutter: stable;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/ExpandableEquipmentList.vue"],"names":[],"mappings":";AA2LA,4GAA4G;AAC5G;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":["\n/* Reserve vertical scrollbar space so expanding the equipment list does not shift the modal horizontally. */\n.incident-detail-modal-body {\n  overflow-y: scroll;\n  scrollbar-gutter: stable;\n}\n\n.modal:has(.incident-detail-modal-body) {\n  scrollbar-gutter: stable;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
